{
    "RunondayMonthLabel": "Esecuzione nel giorno (mese):",
    "RunondayWeekLabel": "Giorno di esecuzione (settimana):",
    "RunondaysLabel": "Eseguire il rapporto sui giorni:",
    "RunbetweenhoursStartLabel": "Eseguire tra un'ora e l'altra:",
    "RunbetweenhoursEndLabel": "E:",
    "RunbetweenhoursNote": "(Incluso su tutta l'ora finale)",
    "RunatminuteHourLabel": "Esecuzione al minuto (ora):",
    "RunatminuteHourNote": "Passato ogni ora (approssimativo)",
    "RunondateLabel": "Eseguire il rapporto alla data:",
    "RunattimeLabel": "Tempo di funzionamento (circa):",
    "TimeOptions_SectionHeader": "Opzioni di tempo",
    "NAME": "TimeOptions"
}